export default "__VITE_ASSET__vhdMTgym__"